// Alt sayfadan geri dönüş (7.6 · D-648).
//
// Cüzdan, bildirim tercihleri, takvim ve Instagram bağlantıları önce profilin
// altındaydı ve geri hep profile dönüyordu. Ayarlar ayrı bir ekran olunca
// (D-501) bu satırlar oraya taşındı ama dönüşler güncellenmedi: Ayarlar'dan
// açılan sayfada geri basınca Profil'e atlanıyordu. Artık sayfa nereden
// açıldıysa oraya döner. Ekrandaki geri tuşu ile Android'in geri tuşu aynı
// kaydı kullanıyor; ikisi ayrı yazıldığı için bir gün ayrışmasınlar diye.
import { useCallback, useState } from 'react';

export function useSubPageReturn<S extends string>(
  setScreen: (screen: S) => void,
  fallback: S,
  // Dönülebilecek yerler. Bildirim açılışta (giriş akışında, yükleme
  // ekranında) bir alt sayfa açarsa oraya dönmek anlamsız; o zaman profile.
  returnable: (screen: S) => boolean,
) {
  const [from, setFrom] = useState<S>(fallback);

  const open = useCallback((page: S, origin: S) => {
    // Zaten açık olan sayfa kendini yeniden açarsa (cüzdandayken para bildirimi)
    // eski kaynak korunur; yoksa geri tuşu sayfayı kendine döndürürdü.
    if (origin !== page) setFrom(returnable(origin) ? origin : fallback);
    setScreen(page);
  }, [setScreen, fallback, returnable]);

  const back = useCallback(() => setScreen(from), [setScreen, from]);

  return { open, back, from };
}
